import { useMemo } from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { useUserClientsWithActiveClient } from 'domains/auth/UserClientsWrapper/useUserClients';
import { getClientRedirect, requiresIntakeAdult, requiresIntakeChild } from 'domains/client';
import { routes } from 'router/routes';

type Props = {
  children?: React.ReactNode;
  clientType: 'adult' | 'child';
};

const IntakeGate = ({ children = <Outlet />, clientType }: Props): JSX.Element => {
  const { activeClient } = useUserClientsWithActiveClient();

  const hasAccess: boolean = useMemo(() => {
    if (!activeClient) {
      return false;
    }

    switch (clientType) {
      case 'adult':
        return requiresIntakeAdult(activeClient);
      case 'child':
        return requiresIntakeChild(activeClient);
      default:
        return false;
    }
  }, [activeClient, clientType]);

  if (!hasAccess) {
    return <Navigate to={activeClient ? getClientRedirect(activeClient, routes.root) : routes.root} />;
  }

  return <>{children}</>;
};

export default IntakeGate;
